import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"],
    _excluded2 = ["children"],
    _excluded3 = ["children"],
    _excluded4 = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react/jsx-pascal-case */

/* Original name @uswitch/trustyle.tble */
import { Themed } from 'theme-ui';
import { jsx as _jsx } from "theme-ui/jsx-runtime";

var Table = function Table(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return _jsx("div", {
    sx: {
      overflowX: ['scroll', 'visible', 'visible'],
      '&::-webkit-scrollbar': {
        display: 'none'
      },
      '&::-ms-overflow-style': {
        display: 'none'
      }
    },
    children: _jsx(Themed.table, _objectSpread(_objectSpread({}, props), {}, {
      children: children
    }))
  });
};

var TableRow = function TableRow(_ref2) {
  var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, _excluded2);

  return _jsx(Themed.tr, _objectSpread(_objectSpread({}, props), {}, {
    children: children
  }));
};

var TableCell = function TableCell(_ref3) {
  var children = _ref3.children,
      props = _objectWithoutProperties(_ref3, _excluded3);

  return _jsx(Themed.td, _objectSpread(_objectSpread({}, props), {}, {
    children: children
  }));
};

var TableHeaderCell = function TableHeaderCell(_ref4) {
  var children = _ref4.children,
      props = _objectWithoutProperties(_ref4, _excluded4);

  return _jsx(Themed.th, _objectSpread(_objectSpread({}, props), {}, {
    children: children
  }));
};

export default {
  wrap: Table,
  td: TableCell,
  tr: TableRow,
  th: TableHeaderCell
};
//# sourceMappingURL=table.js.map